import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import path from '../../helpers/path';
export var REQUEST_PRODUCT_MANIFEST = 'REQUEST_PRODUCT_MANIFEST';
export var RECEIVE_PRODUCT_MANIFEST = 'RECEIVE_PRODUCT_MANIFEST';
export var ERROR_PRODUCT_MANIFEST = 'ERROR_PRODUCT_MANIFEST';
export var getProductManifest = function getProductManifest() {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(requestingProductManifest);
              fetch(path('/local/product-manifest.json')).then(function (res) {
                return res.json();
              }).then(function (json) {
                dispatch(receiveProductManifest(json));
              }).catch(function (error) {
                dispatch(errorProductManifest(error));
              });
            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var requestingProductManifest = {
  type: REQUEST_PRODUCT_MANIFEST,
  payload: {}
};
var receiveProductManifest = function receiveProductManifest(payload) {
  return {
    type: RECEIVE_PRODUCT_MANIFEST,
    payload: payload
  };
};
var errorProductManifest = function errorProductManifest(payload) {
  return {
    type: ERROR_PRODUCT_MANIFEST,
    payload: payload
  };
};